import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { OperatingManualStyleContext } from "../../../../../contexts/OperatingManualStyleContext";
import { useContext } from "react";

const DeviceLifetimeExpectancy = () => {
  const { t } = useTranslation();
  const { sectionContainerStyle } = useContext(OperatingManualStyleContext);

  return (
    <div id="device-lifetime-expectancy">
      <Box sx={{ ...sectionContainerStyle, padding: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            background:
              "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
            color: "white",
            p: 1,
            pl: 4,
            borderRadius: 2,
            mb: 2,
            boxShadow: "0px 0.625rem 3rem 0px rgba(0, 0, 0, 0.06)",
          }}
        >
          {" "}
          <Typography variant="h6" fontWeight={"bold"} color={"white"}>
            {t("operating_manual_device_lifetime_expectancy")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            pl: 4,
            pr: 4,
          }}
        >
          <Typography>
            {t(
              "The estimated operational lifetime of this device is five (5) years under normal use conditions, as outlined in this manual. "
            )}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default DeviceLifetimeExpectancy;
